import {
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  OnDestroy,
  PLATFORM_ID,
  Inject,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { FilterComponent, ViewMode } from '../filter/filter.component';
import { ApiService } from '../../shared/services/api.service';
import { CartService } from '../../shared/services/cart.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CommonModule,
  isPlatformBrowser,
  ViewportScroller,
} from '@angular/common';
import { PaginationComponent } from '../../shared/components/pagination/pagination.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BuyNowButtonComponent } from '../buy-now-button/buy-now-button.component';
import { BuyNowPopupComponent } from '../buy-now-popup/buy-now-popup.component';
import { LoaderService } from '../../shared/services/loader.service';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { AuthService } from '../../shared/services/auth.service';
import { environment } from '../../../environment/environment';
import { BreadcrumComponent } from '../breadcrum/breadcrum.component';
import { ScrapCertificateService } from '../../shared/services/scrap-certificate.service';
import { ScrapCertificateModalComponent } from '../../shared/components/scrap-certificate-modal/scrap-certificate-modal.component';
import { NotificationService } from '../../shared/services/notification.service';
import { ProductNamePipe } from '../../shared/pipes/product-name.pipe';
import { DeliveryDateService } from '../../shared/services/delivery-date.service';

@Component({
  selector: 'app-product-list',
  standalone: true,
  imports: [
    CommonModule,
    FilterComponent,
    PaginationComponent,
    ReactiveFormsModule,
    BuyNowButtonComponent,
    BuyNowPopupComponent,
    BreadcrumComponent,
    ScrapCertificateModalComponent,
    ProductNamePipe,
  ],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss',
})
export class ProductListComponent implements OnInit, OnDestroy {
  mostSearchedModels: any;
  garageData: any;
  canScrollRightDirection(): any {
    throw new Error('Method not implemented.');
  }
  private sub: Subscription = new Subscription();
  text: string = 'home';
  text1: any;
  isActive: boolean = false;
  toggleActive: boolean = false;
  gridView: boolean = false;
  selectedView: ViewMode = 'grid';
  isFromWishlist: boolean = false;
  selectedTab: 'scrap' | null = null;

  isScrap: boolean = false;
  categories: any[] = [];
  @ViewChild(BreadcrumComponent) breadCrumb!: BreadcrumComponent;
  @ViewChild(FilterComponent) filterComponent!: FilterComponent;
  @ViewChild('carousel', { static: false }) carousel!: ElementRef;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  breadcrumbData: any[] = [];
  currentPage = 1;
  totalPagesValue = 0;
  currentPageValue = 1;
  showPagination = true;
  limit = 12;
  offset = 0;
  productCount = 0;

  sidebarCategory: Category = {
    id: 0,
    title: 'Axle',
    imageUrl:
      'https://cdn.builder.io/api/v1/image/assets/TEMP/541062116edc0f669eabf3779cf8716f39e01597?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
    partsCount: 1245,
    backgroundColor: 'bg-zinc-100',
    selected: true,
  };

  categoriess: Category[] = [];
  isMobile: boolean = false;
  hoveredProduct: any = null;
  itemAddedToCart = new Map<string, boolean>(); // Track success state for each product by part number
  imageScrollInterval: any = null; // Store interval timer for auto-scrolling images

  isScrapPart: boolean = true;
  searchText: any;
  selectedFilters: any;
  get_your_vehicles: boolean = false;

  // Filter data properties
  brands: any[] = [];
  models: any[] = [];
  variants: any[] = [];
  years: any[] = [];
  sellers: any[] = [];
  qualities: any[] = [];
  locations: any[] = [];
  priceRanges: any[] = [];
  minValue: number = 0;
  maxValue: number = 10000;
  is_scrap_see_more: boolean = false;
  get_popular_brands: boolean = false;
  get_popular_vehicles: boolean = false;
  get_popular_categories: boolean = false;
  get_popular_parts: boolean = false;
  get_popular_scrap: boolean = false;
  get_most_search_VeiwAll: boolean = false;
  filterpassData: any;
  constructor(
    private apiService: ApiService,
    private cartService: CartService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private behaviourSubject: BehaviourSubjectService,
    private authService: AuthService,
    private viewportScroller: ViewportScroller,
    private cdr: ChangeDetectorRef,
    private scrapCertificateService: ScrapCertificateService,
    private notificationService: NotificationService,
    private deliveryDateService: DeliveryDateService
  ) {
    const navigation = this.router.getCurrentNavigation();
    // if (navigation?.extras.state) {
    //   this.searchText = navigation.extras.state['searchText'];
    //   // this.getProductList();
    // }
  }
  private firstSearchHandled = false;
  sparePartsType: any;
  guideSearch: any;
  categoryData: any;
  selectedCategoryId: number | null = null;
  selectedCategory: any = null;
  selectedSubcategoryId: string | null = null;
  selectedSubcategory: any = null;
  subcategories: any[] = [];
  showSubcategories: boolean = false;
  canScrollLeft: boolean = false; // Track if left scroll is possible

  @HostListener('window:resize')
  onResize() {
    this.checkIfMobile();
  }

  products: any[] = [];
  productsCount: number = 0;
  productData: any[] = [];
  isBuyNowPopupOpen = false;
  selectedProductForBuyNow: any = null;
  pendingBuyNowProduct: any = null; // Store product for buy now after login
  showScrapCertificateModal = false;

  // Add flag to prevent multiple simultaneous API calls
  private isApiCallInProgress = false;
  // Prevent any late emissions (subjects/debounce) from calling APIs after route leave
  private isDestroyed = false;
  // Template-facing loading flag (prevents blank PLP)
  isLoading = false;
  private initializationComplete = false;
  private debounceTimeout: any = null;
  private userSelectedCategory: boolean = false;

  ngOnInit() {
    // Show loader immediately when component initializes to prevent "no data found" flash
    this.loaderService.show();

    // Scroll to top when component initializes
    this.scrollToTop();

    // Initialize carousel scroll state after view is initialized
    setTimeout(() => {
      this.onCarouselScroll();
    }, 100);

    // Browser-specific operations
    if (isPlatformBrowser(this.platformId)) {
      // Handle localStorage data
      const storedData = localStorage.getItem('guideSearchData');
      const seeMore = localStorage.getItem('seemore');
      const category = localStorage.getItem('category');
      const categoryType = JSON.parse(
        localStorage.getItem('categoryType') || 'null',
      );
      this.sparePartsType = JSON.parse(
        localStorage.getItem('SpareCategory') || 'null',
      );

      this.mostSearchedModels = JSON.parse(
        localStorage.getItem('mostSearchedModel') || 'null',
      );

      this.garageData = JSON.parse(
        localStorage.getItem('MyGarageData') || 'null',
      );

      if (categoryType) {
        this.isScrapPart = categoryType === 'Scrap Part';
      } else if (this.categoryData?.type) {
        this.isScrapPart = this.categoryData.type === 'Scrap Part' || this.categoryData.type === 'scrap';
      } else if (this.guideSearch?.part_type) {
        this.isScrapPart = this.guideSearch.part_type === 'Scrap Part';
      }

      this.categoryData = category ? JSON.parse(category) : null;

      // Set filterpassData based on priority: categoryData > mostSearchedModels
      if (this.categoryData) {
        this.selectedCategoryId = this.categoryData.id;
        this.selectedCategory = this.categoryData;
        this.filterpassData = this.categoryData;

        // Check if category has subcategories and show them
        // Note: subcategories will be set after categories are loaded from API
        this.subcategories = [];
        this.showSubcategories = false;
      } else if (this.mostSearchedModels) {
        this.filterpassData = this.mostSearchedModels;
      } else if (this.sparePartsType) {
        this.filterpassData = this.sparePartsType;
      }

      // Trigger change detection to ensure filter component receives the data
      this.cdr.detectChanges();
      this.get_your_vehicles = seeMore === 'your_vehicles';
      this.is_scrap_see_more = seeMore === 'popular_scrap';
      this.get_popular_brands = seeMore === 'popular_brands';
      this.get_popular_vehicles = seeMore === 'popular_vehicles';
      this.get_popular_categories = seeMore === 'popular_categories';
      this.get_popular_parts = seeMore === 'popular_parts';
      this.get_popular_scrap = seeMore === 'popular_scrap';
      this.get_most_search_VeiwAll = seeMore === 'mostSearchedModels';
      this.guideSearch = storedData ? JSON.parse(storedData) : null;
      this.filterpassData = this.guideSearch;
      const navState = history.state;
      const userAgent = navigator.userAgent;
      this.isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent,
        ) && window.innerWidth < 480;

      this.sub.add(
        this.route.queryParams.subscribe((params) => {
          this.isFromWishlist = params['from'] === 'wishlist';
          this.breadcrumbData = [params['type']];
        }),
      );

      this.sub.add(
        this.behaviourSubject.selectedFilters$.subscribe((filters) => {
          this.selectedFilters = filters;
          console.log('Received new filters in ProductListComponent:', filters);
          
          // If filters are cleared (null or empty object) from header search, reset filter component UI
          if ((!filters || Object.keys(filters).length === 0) && this.initializationComplete && this.filterComponent) {
            // Use resetFiltersForHeaderSearch to avoid clearing the search text
            this.filterComponent.resetFiltersForHeaderSearch();
            
            // Also check if localStorage was cleared (indicating header search) and clear category state
            if (isPlatformBrowser(this.platformId)) {
              const hasCategory = localStorage.getItem('category');
              const hasCategoryType = localStorage.getItem('categoryType');
              const hasGuideSearch = localStorage.getItem('guideSearchData');
              
              if (!hasCategory && !hasCategoryType && !hasGuideSearch) {
                // Clear ALL category-related state when filters are cleared from header search
                this.selectedCategoryId = null;
                this.selectedCategory = null;
                this.selectedSubcategoryId = null;
                this.selectedSubcategory = null;
                this.subcategories = [];
                this.showSubcategories = false;
                this.categoryData = null;
                this.filterpassData = null;
                this.guideSearch = null;
                this.mostSearchedModels = null;
                this.sparePartsType = null;
                this.garageData = null;
                this.userSelectedCategory = false;
                
                // Clear "see more" flags
                this.get_your_vehicles = false;
                this.is_scrap_see_more = false;
                this.get_popular_brands = false;
                this.get_popular_vehicles = false;
                this.get_popular_categories = false;
                this.get_popular_parts = false;
                this.get_popular_scrap = false;
                this.get_most_search_VeiwAll = false;
              }
            }
          }
          
          // Only call API if initialization is complete and not from filter component's own call
          if (this.initializationComplete) {
            this.debouncedGetProductList();
          }
        }),
      );

      this.sub.add(
        this.behaviourSubject.searchTerm$.subscribe((term) => {
          this.searchText = term || '';
          
          // If new search term comes and localStorage has been cleared by header (indicating fresh search),
          // reset all category-related state to prevent mixing old category with new search
          if (term && this.initializationComplete && isPlatformBrowser(this.platformId)) {
            const hasCategory = localStorage.getItem('category');
            const hasCategoryType = localStorage.getItem('categoryType');
            const hasGuideSearch = localStorage.getItem('guideSearchData');
            
            // If localStorage was cleared but we still have category state, clear it
            if (!hasCategory && !hasCategoryType && !hasGuideSearch) {
              // Reset ALL category and filter related state
              this.selectedCategoryId = null;
              this.selectedCategory = null;
              this.selectedSubcategoryId = null;
              this.selectedSubcategory = null;
              this.subcategories = [];
              this.showSubcategories = false;
              this.categoryData = null;
              this.filterpassData = null;
              this.guideSearch = null;
              this.mostSearchedModels = null;
              this.sparePartsType = null;
              this.garageData = null;
              this.userSelectedCategory = false;
              
              // Clear "see more" flags
              this.get_your_vehicles = false;
              this.is_scrap_see_more = false;
              this.get_popular_brands = false;
              this.get_popular_vehicles = false;
              this.get_popular_categories = false;
              this.get_popular_parts = false;
              this.get_popular_scrap = false;
              this.get_most_search_VeiwAll = false;
              
              // Reset pagination
              this.currentPage = 1;
              this.offset = 0;
            }
          }
          
          if (this.initializationComplete) {
            this.debouncedGetProductList();
          }
        }),
      );

      // Listen for category changes from header
      // this.sub.add(
      //   this.behaviourSubject.categoryChanged$.subscribe((categoryData) => {
      //     if (categoryData) {
      //       this.sparePartsType = [];
      //       // Clear filters when navigation comes from header categories
      //       this.clearFiltersFromHeaderNavigation();
      //       this.loadDataFromLocalStorage();
      //     }
      //   })
      // );
      this.sub.add(
        this.behaviourSubject.categoryChanged$.subscribe((categoryData) => {
          if (categoryData) {
            // 🔥 1. Update scrap flag correctly
            // this.isScrapPart = categoryData?.type === 'Scrap Part';

            // 🔥 2. Reset ALL state properly
            this.selectedCategory = null;
            this.selectedCategoryId = null;
            this.selectedSubcategory = null;
            this.selectedSubcategoryId = null;
            this.subcategories = [];
            this.showSubcategories = false;
        

            // 🔥 3. Reset filters
            this.selectedFilters = {};
            this.behaviourSubject.clearSelectedFilters();

            // 🔥 4. Clear search
            this.searchText = '';
            this.behaviourSubject.setSearchTerm('');

            // 🔥 5. Reload localStorage data (new category)
            this.loadDataFromLocalStorage();

            // 🔥 6. VERY IMPORTANT → trigger API
            this.currentPage = 1;
            this.offset = 0;
            this.getProductList();

            this.cdr.detectChanges();
          }
        }),
      );

      // Listen for user login success to handle pending buy now action
      this.sub.add(
        this.authService.isLoggedIn$.subscribe((isLoggedIn) => {
          if (isLoggedIn && this.pendingBuyNowProduct) {
            // User just logged in and we have a pending buy now action
            setTimeout(() => {
              this.selectedProductForBuyNow = this.pendingBuyNowProduct;
              this.isBuyNowPopupOpen = true;
              this.pendingBuyNowProduct = null; // Clear the pending action
              this.cdr.detectChanges(); // Force change detection
            }, 800); // Increased delay to ensure login modal is fully closed and auth state is stable
          }
        }),
      );
      if (this.guideSearch) {
        // this.isScrapPart =
        //   this.guideSearch?.part_type === 'Scrap Part' || this.is_scrap_see_more
        //     ? true
        //     : false;
        // Set initialization complete after processing guide search
        this.initializationComplete = true;
        this.getProductList();
      } else if (navState?.searchText) {
        this.searchText = navState.searchText;
        this.initializationComplete = true;
        this.getProductList();
        this.firstSearchHandled = true;
      } else {
        // Set initialization complete and make single API call
        this.initializationComplete = true;
        this.getProductList();
      }
    }

    // Products initialization is handled in getProductList() after API response
    // No need to initialize empty products array here

    this.filterpassData = this.guideSearch
      ? this.guideSearch
      : this.categoryData
        ? this.categoryData
        : this.mostSearchedModels;
    // this.breadcrumbData = [params.get('lob_name'), params.get('sub_lob'), params.get('ppl_name')];

    // Sync scrap certificate modal state with shared service
    this.sub.add(
      this.scrapCertificateService.showScrapCertificateModal$.subscribe(
        (show) => {
          this.showScrapCertificateModal = show;
          this.cdr.detectChanges();
        },
      ),
    );
  }

  scrollLeft() {
    if (this.scrollContainer) {
      const container = this.scrollContainer.nativeElement;
      const cardWidth = 220; // Width of card + gap
      container.scrollLeft -= cardWidth;
    }
  }

  scrollRight() {
    if (this.scrollContainer) {
      const container = this.scrollContainer.nativeElement;
      const cardWidth = 220; // Width of card + gap
      container.scrollLeft += cardWidth;
    }
  }
  togglefilter() {
    this.toggleActive = !this.toggleActive;
  }

  // Buy Now popup state management

  onBuyNow(productData: any) {
    // For scrap parts, require explicit valid quantity selection before proceeding
    if (productData?.part_type === 'Scrap Part') {
      // Mark as touched to show any validation messages in UI
      productData.quantityTouched = true;
      this.cdr.markForCheck();
      if (this.shouldDisableButtons(productData)) {
        // Block opening popup until user fixes quantity
        // this.notificationService.error(
        //   'Please select a valid quantity before proceeding',
        // );
        this.cdr.markForCheck();
        return;
      }
    }

    // Check if user is logged in using AuthService for more reliable state
    if (!this.authService.isLoggedIn) {
      // Store the product for buy now after login
      this.pendingBuyNowProduct = productData;
      // this.notificationService.info(
      //   'Please log in to continue with your purchase',
      // );
      this.openLoginPopup();
      return;
    }

    // Check if this is a scrap part
    if (this.scrapCertificateService.isScrapPart(productData)) {
      // For scrap parts, check certificate match before proceeding to buy now
      this.scrapCertificateService.handleAddToCart(
        productData,
        () => {
          // Callback for when certificate matches - proceed with buy now
          this.selectedProductForBuyNow = productData;
          this.isBuyNowPopupOpen = true;
          this.cdr.detectChanges();
        },
        () => {
          // Callback for login required (shouldn't reach here since we already checked above)
          this.pendingBuyNowProduct = productData;
          this.openLoginPopup();
        },
      );
      return;
    }

    // For non-scrap parts, proceed with buy now directly
    this.selectedProductForBuyNow = productData;
    this.isBuyNowPopupOpen = true;
    this.cdr.detectChanges();
  }

  onPaymentSuccess(event: any) {
    // Hide any active loaders before navigation
    this.loaderService.hide();
    this.closeBuyNowPopup();

    // Show success notification

    // Navigate to order confirmation page with order details
    if (event && event.data) {
      this.router.navigate(['/order-confirmation'], {
        state: { orderDetail: event.data },
      });
    } else {
      // Fallback navigation if no order details
      this.router.navigate(['/order-confirmation']);
    }
  }

  closeBuyNowPopup() {
    this.isBuyNowPopupOpen = false;
    this.selectedProductForBuyNow = null;
    this.pendingBuyNowProduct = null; // Clear pending action when popup is closed
  }

  onViewChange(view: ViewMode): void {
    this.selectedView = view;
  }

  handlePageChange(page: number) {
    this.currentPageValue = page;
    this.currentPage = page;
    this.offset = (page - 1) * this.limit;
    // Scroll to top when page changes
    this.scrollToTop();
    this.getProductList();
  }

  togglePagination() {
    this.showPagination = !this.showPagination;
  }

  checkIfMobile() {
    // Only check mobile view if we're in browser environment
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 640;
    }
  }

  // Method to check if left scroll button should be visible
  canScrollLeftDirection(): boolean {
    if (!this.carousel) return false;
    return this.carousel.nativeElement.scrollLeft > 0;
  }

  // Method to handle carousel scroll events
  onCarouselScroll() {
    if (this.carousel) {
      this.canScrollLeft = this.carousel.nativeElement.scrollLeft > 0;
    }
  }

  scrollCarousel(direction: number) {
    if (this.carousel) {
      const scrollAmount = 210; // Adjusted scroll amount based on card width + gap
      this.carousel.nativeElement.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth',
      });

      // Update scroll state after scrolling
      setTimeout(() => {
        this.onCarouselScroll();
      }, 300); // Wait for smooth scroll to complete
    }
  }

  selectCategory(category: any) {
    if (this.filterComponent) {
      this.filterComponent.resetFiltersForCategoryChange();
    }
    this.selectedCategoryId = category.id;
    this.selectedCategory = category;
    this.filterpassData = category;
    // Clear default categoryData so manual selection takes precedence in UI
    this.categoryData = null;
    this.userSelectedCategory = true;
    this.cdr.detectChanges();

    // Reset subcategory selection when selecting a new category
    this.selectedSubcategoryId = null;
    this.selectedSubcategory = null;

    // Clear search text when switching categories
    this.searchText = '';
    this.behaviourSubject.setSearchTerm('');

    // --- FIX: Update selectedFilters.categories so API payload is correct ---
    if (!this.selectedFilters) {
      this.selectedFilters = {};
    }
    this.selectedFilters.categories = [category.name];
    this.behaviourSubject.setSelectedFilters(this.selectedFilters);
    // --- END FIX ---

    // Check if category has subcategories
    if (category.subcategories && category.subcategories.length > 0) {
      this.subcategories = category.subcategories;
      this.showSubcategories = true;
    } else {
      this.subcategories = [];
      this.showSubcategories = false;
    }

    // Scroll to the beginning of the carousel
    if (this.carousel) {
      this.carousel.nativeElement.scrollTo({
        left: 0,
        behavior: 'smooth',
      });

      // Update scroll state after scrolling
      setTimeout(() => {
        this.onCarouselScroll();
      }, 300);
    }

    this.currentPageValue = 1;
    this.currentPage = 1;
    this.offset = 0;

    this.getProductList();

    // Force change detection to ensure filter component updates
    this.cdr.detectChanges();

    // Emit an event or handle the filter logic here
  }

  deselectCategory() {
    if (this.filterComponent) {
      this.filterComponent.resetFiltersForCategoryChange();
    }
    this.selectedCategoryId = null;
    this.selectedCategory = null;
    this.selectedSubcategoryId = null;
    this.selectedSubcategory = null;
    this.userSelectedCategory = false;
    this.subcategories = [];
    this.showSubcategories = false;
    this.categoryData = null; // Clear categoryData when deselecting
    this.filterpassData = null; // Clear filterpassData when deselecting

    // Clear search text when deselecting categories
    this.searchText = '';
    this.behaviourSubject.setSearchTerm('');

    // Reset scroll position and update state
    if (this.carousel) {
      this.carousel.nativeElement.scrollTo({
        left: 0,
        behavior: 'smooth',
      });

      // Update scroll state after scrolling
      setTimeout(() => {
        this.onCarouselScroll();
      }, 300);
    }

    this.currentPageValue = 1;
    this.currentPage = 1;
    this.offset = 0;
    this.getProductList();

    // Force change detection to ensure UI updates
    this.cdr.detectChanges();
  }

  isSubcategorySelected(subcategory: any): boolean {
    const subcategoryName = subcategory?.name;
    // Use name as the unique identifier since subcategories don't have id
    const isSelected = subcategoryName === this.selectedSubcategoryId;

    return isSelected;
  }

  deselectSubcategory() {
    this.selectedSubcategoryId = null;
    this.selectedSubcategory = null;

    // Clear search text when deselecting subcategories
    this.searchText = '';
    this.behaviourSubject.setSearchTerm('');

    this.currentPageValue = 1;
    this.currentPage = 1;
    this.offset = 0;
    this.getProductList();
  }

  getSelectedCategory() {
    // Prefer the cached selectedCategory object if available (immediate UI update)
    if (this.selectedCategory) {
      return this.selectedCategory;
    }
    // Fall back to default categoryData (from navigation/localStorage)
    if (this.categoryData) {
      return this.categoryData;
    }
    // As a last resort, try to resolve from categories array via id
    if (this.selectedCategoryId !== null) {
      const byId = this.categories.find(
        (cat) => String(cat.id) === String(this.selectedCategoryId),
      );
      return byId || null;
    }
    return null;
  }

  getSelectedSubcategory() {
    return this.selectedSubcategory;
  }

  getFilteredCategories() {
    if (this.showSubcategories) {
      // If showing subcategories, always show all subcategories (selected one is shown separately)
      return this.subcategories;
    } else if (this.selectedCategoryId !== null) {
      // If a category is selected manually, show only non-selected categories
      return this.categories.filter(
        (category) => category.id !== this.selectedCategoryId,
      );
    } else if (this.categoryData) {
      // If categoryData exists but no category is selected, show only the categoryData category
      return this.categories.filter(
        (category) => category.id === this.categoryData.id,
      );
    }
    // If no category is selected and no categoryData, show all categories
    return this.categories;
    this.cdr.detectChanges();
  }

  selectSubcategory(subcategory: any) {
    const subcategoryName = subcategory?.name;
    // if (!subcategoryName) {
    //   this.notificationService.error(
    //     `${subcategoryName}Subcategory name is undefined!`,
    //   );
    //   return;
    // }

    // If clicking on the already selected subcategory, deselect it
    if (this.selectedSubcategoryId === subcategoryName) {
      this.deselectSubcategory();
      return;
    }
    this.selectedSubcategoryId = subcategoryName;
    this.selectedSubcategory = subcategory;

    // Clear search text when switching subcategories
    this.searchText = '';
    this.behaviourSubject.setSearchTerm('');

    this.currentPageValue = 1;
    this.currentPage = 1;
    this.offset = 0;

    this.getProductList();
    this.cdr.detectChanges();
    // You can add additional logic for subcategory selection
  }

  getProductList() {
    // Component is destroyed; ignore any late emissions/debounced calls
    if (this.isDestroyed) {
      return;
    }
    // Prevent multiple simultaneous API calls
    if (this.isApiCallInProgress) {
      console.log('API call already in progress, skipping...');
      return;
    }

    this.isApiCallInProgress = true;
    this.isLoading = true;
    this.loaderService.show();
    const garageData = JSON.parse(
      localStorage.getItem('MyGarageData') || 'null',
    );
    // Scroll to top when product list is refreshed
    this.scrollToTop();

    try {
      let sortBy = '';
      // if (this.selectedFilters?.sort_by) {
      if (this.selectedFilters?.sort_by === 'newToOld' && !this.isScrapPart) {
        sortBy = 'CREATED_AT_dt%20desc';
      } else if (
        this.selectedFilters?.sort_by === 'oldToNew' &&
        !this.isScrapPart
      ) {
        sortBy = 'CREATED_AT_dt%20asc';
      } else if (
        this.selectedFilters?.sort_by === 'priceLowHigh' &&
        !this.isScrapPart
      ) {
        sortBy = 'PRICE_f%20asc';
      } else if (
        this.selectedFilters?.sort_by === 'priceHighLow' &&
        !this.isScrapPart
      ) {
        sortBy = 'PRICE_f%20desc';
      } else if (
        this.selectedFilters?.sort_by === 'priceHighLow' &&
        this.isScrapPart
      ) {
        sortBy = 'PRICE_f%20desc';
      } else if (
        this.selectedFilters?.sort_by === 'priceLowHigh' &&
        this.isScrapPart
      ) {
        sortBy = 'PRICE_f%20asc';
      } else if (
        this.selectedFilters?.sort_by === 'newToOld' &&
        this.isScrapPart
      ) {
        sortBy = 'CREATED_AT_dt%20desc';
      } else if (
        this.selectedFilters?.sort_by === 'oldToNew' &&
        this.isScrapPart
      ) {
        sortBy = 'CREATED_AT_dt%20asc';
      } else {
        sortBy = '';
      }
      // }

      let subCategoryList: any = '';

      if (this.guideSearch?.part_type === 'Scrap Part') {
        subCategoryList = this.guideSearch?.model
          ? [this.guideSearch?.model]
          : [];
      } else if (this.isScrapPart) {
        if (this.selectedFilters?.subcategories) {
          subCategoryList = this.selectedFilters.subcategories;
        } else if (this.selectedSubcategory?.name) {
          subCategoryList = [this.selectedSubcategory.name];
        }
      }

      // this.sub_category_list = subCategoryList;

      let data = {
        // "sort_by": this.searchText ? this.searchText : '',//"SOLR_LAST_UPD_dt%20desc"
        search_text: this.searchText || this.guideSearch?.search_text || '',
        limit: this.limit,
        offset: this.offset,

        make_list:[],
          // this.guideSearch?.part_type === 'Scrap Part'
          //   ? ''
          //   : this.isScrapPart
          //     ? ''
          //     : this.guideSearch?.make
          //       ? [this.guideSearch.make]
          //       : this.selectedFilters?.brands
          //         ? this.selectedFilters.brands
          //         : garageData?.make
          //           ? [garageData?.make]
          //           : this.sparePartsType?.VEHICLE_MAKE_s
          //             ? [this.sparePartsType.VEHICLE_MAKE_s]
          //             : this.mostSearchedModels?.make
          //               ? [this.mostSearchedModels.make]
          //               : [],

        group_name: '',
          // this.guideSearch?.part_type === 'Scrap Part'
          //   ? ''
          //   : this.isScrapPart
          //     ? ''
          //     : this.selectedCategory?.name
          //       ? this.selectedCategory?.name
          //       : this.categoryData?.name
          //         ? this.categoryData?.name
          //         : '',

        group_name_list: '',
        franchise_list: this.selectedFilters?.sellers
          ? this.selectedFilters?.sellers
          : '',

        year_of_manufacture:'',
          // this.guideSearch?.part_type === 'Scrap Part' || this.isScrapPart
          //   ? ''
          //   : garageData?.year_of_manufacture
          //     ? garageData?.year_of_manufacture
          //     : this.guideSearch?.year_of_manufacture
          //       ? this.guideSearch?.year_of_manufacture
          //       : this.selectedFilters?.year_of_manufacture
          //         ? this.selectedFilters?.year_of_manufacture
          //         : this.sparePartsType?.YEAR_OF_MANUFACTURE_s
          //           ? this.sparePartsType.YEAR_OF_MANUFACTURE_s
          //           : '',

        year_of_manufacture_list: '',
          // this.guideSearch?.part_type === 'Scrap Part' || this.isScrapPart
          //   ? ''
          //   : this.selectedFilters?.years
          //     ? this.selectedFilters?.years
          //     : '',
        grade_list: this.selectedFilters?.grades
          ? this.selectedFilters?.grades
          : '',
        parent_model: '',
          // this.guideSearch?.part_type === 'Scrap Part'
          //   ? ''
          //   : this.isScrapPart
          //     ? ''
          //     : this.selectedFilters?.model // Add model from vehicle form filters
          //       ? this.selectedFilters?.model
          //       : this.guideSearch?.model
          //         ? this.guideSearch?.model
          //         : this.sparePartsType?.PARENT_MODEL_s
          //           ? this.sparePartsType.PARENT_MODEL_s
          //           : this.mostSearchedModels?.model
          //             ? this.mostSearchedModels.model
          //             : garageData?.model
          //               ? garageData?.model
          //               : '',

        // variant: this.guideSearch?.part_type === 'Scrap Part' || this.isScrapPart ? '' :garageData?.variant
        //   ? garageData?.variant
        //   : this.guideSearch?.variant
        //   ? this.guideSearch?.variant
        //   : this.selectedFilters?.variant
        //   ? this.selectedFilters?.variant
        //   : this.sparePartsType?.VARIANT_s
        //   ? this.sparePartsType.VARIANT_s
        //   : '',

        variant_list: [],
        // this.selectedFilters?.variants
        //   ? this.selectedFilters.variants
        //   : garageData?.variant
        //     ? [garageData.variant]
        //     : this.guideSearch?.variant
        //       ? [this.guideSearch.variant]
        //       : this.sparePartsType?.VARIANT_s
        //         ? [this.sparePartsType.VARIANT_s]
        //         : [],

        part_type: 'Scrap Part',
          // this.guideSearch?.part_type === 'Scrap Part'
          //   ? this.guideSearch?.part_type
          //   : this.isScrapPart
          //     ? 'Scrap Part'
          //     : garageData?.part_type || 'Used Part', // this.guideSearch?.part_type ? this.guideSearch.part_type : '',
        is_scrap_see_more: this.is_scrap_see_more,
        // get_your_vehicles: this.get_your_vehicles,
        // get_popular_brands: this.get_popular_brands,
        // get_popular_vehicles: this.get_popular_vehicles,
        get_popular_categories: this.get_popular_categories,
        // get_popular_parts: this.get_popular_parts,
        get_popular_scrap: this.get_popular_scrap,
        get_most_search_parts: this.get_most_search_VeiwAll,
        location_list: this.selectedFilters?.locations
          ? this.selectedFilters?.locations
          : '',
        price_range: this.selectedFilters?.price_range
          ? this.selectedFilters?.price_range
          : '',
        sort_by: sortBy ? sortBy : '',

        is_used_see_more:
          this.get_popular_parts ||
          this.get_popular_categories ||
          this.get_popular_vehicles ||
          this.get_popular_brands ||
          this.get_your_vehicles
            ? true
            : false,
        table_name:'',
        //  this.isScrapPart
        //   ? ''
        //   : this.selectedSubcategory?.name
        //     ? this.selectedSubcategory?.name
        //     : '',
        table_name_list:'',
        //  this.isScrapPart
        //   ? ''
        //   : this.selectedFilters?.subcategories
        //     ? this.selectedFilters?.subcategories
        //     : [],
        category_list:
          this.guideSearch?.part_type === 'Scrap Part' || this.isScrapPart
            ? this.guideSearch?.make
              ? [this.guideSearch.make]
              : this.selectedFilters?.categories
                ? this.selectedFilters.categories
                : this.selectedCategory?.name
                  ? [this.selectedCategory.name]
                  : this.categoryData?.name
                    ? [this.categoryData.name]
                    : []
            : '',

        sub_category_list: subCategoryList,
      };

      console.log('Product List API Payload:', data);
      console.log('Selected Filters Variants:', this.selectedFilters?.variants);
      console.log('Selected Filters Model:', this.selectedFilters?.model);
      console.log('Variant List in Payload:', data.variant_list);
      console.log('Parent Model in Payload:', data.parent_model);

      this.sub.add(
        this.apiService.getProductlistData(data).subscribe({
          next: (value) => {
            if (value.success) {
              this.productsCount = value.data.total_result;
              this.products = value.data.part_list;
              this.productData = value.data.part_list;
              this.text1 = value.data.part_list[0]?.short_desc_s;
              this.totalPagesValue = Math.ceil(
                value.data.total_result / this.limit,
              );
              this.showPagination = this.productsCount > this.limit;

              // Reset API call flag
              this.isApiCallInProgress = false;
              this.isLoading = false;

              // Quick initialization - assign products array directly with minimal processing
              // This allows the view to render immediately
              const productsLength = this.products.length;
              for (let i = 0; i < productsLength; i++) {
                const product = this.products[i];

                // Minimal initialization for immediate render
                product.images = Array.isArray(product.part_image_path)
                  ? product.part_image_path
                  : product.part_image_path
                    ? [product.part_image_path]
                    : [];
                product.currentImageIndex = 0;

                // Cache heavy calculation result to avoid repeated expensive calls in template
                const isLiterProduct =
                  product.default_uom === 'ltr' ||
                  product.default_uom === 'litr' ||
                  product.default_uom === 'liter';
                product.isOilProduct = isLiterProduct; // Cached property for template
                product.selectedUnit = isLiterProduct ? 'liter' : 'ton';

                if (product.part_type === 'Scrap Part') {
                  product.quantity = null;
                  product.customKgQuantity = null;
                  product.customTonQuantity = null;
                  if (isLiterProduct) {
                    product.customLiterQuantity = null;
                  }
                } else {
                  product.quantity = 1;
                  product.customKgQuantity = null;
                }
                product.quantityTouched = false;
              }

              // Hide loader and trigger immediate UI update
              this.loaderService.hide();
              this.cdr.detectChanges();

              // Load filters without blocking the PLP render
              this.getFilterList(false);
            } else {
              this.products = [];
              this.productsCount = 0;
              // Reset API call flag
              this.isApiCallInProgress = false;
              this.isLoading = false;
              // Hide loader immediately
              this.loaderService.hide();
              this.cdr.detectChanges();
              // Load filters without delay
              this.getFilterList(false);
            }
          },
          error: (err) => {
            // Reset API call flag
            this.isApiCallInProgress = false;
            this.isLoading = false;

            // Only show error if it's not a cancellation
            if (
              err.message !== 'Request cancelled' &&
              err.name !== 'AbortError'
            ) {
              // this.notificationService.error(
              //   err.error?.data?.msg ||
              //     'Failed to load products. Please try again.',
              // );
            }
            // Hide loader on error
            this.loaderService.hide();
            // Trigger change detection to update view
            this.cdr.detectChanges();
          },
          complete: () => {
            // Ensure API call flag is reset
            this.isApiCallInProgress = false;
            this.isLoading = false;
            // Loader is already hidden in next/error callbacks
          },
        }),
      );
    } catch (error: any) {
      // Reset API call flag
      this.isApiCallInProgress = false;
      // this.notificationService.error(
      //   error.error?.data?.msg ||
      //     'An unexpected error occurred. Please try again.',
      // );
      this.loaderService.hide();
      throw error;
    }
  }

  // Debounced version of getProductList to prevent rapid successive calls
  private debouncedGetProductList() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      if (this.isDestroyed) {
        return;
      }
      // Only call if no API call is in progress
      if (!this.isApiCallInProgress) {
        this.getProductList();
      }
    }, 300); // 300ms debounce
  }

  gotoProductDetails(data: any) {
    if (!data) return;
    let type = this.isScrapPart ? 'Scrap Part' : 'Used Part';
    localStorage.removeItem('product_categoryType');
    localStorage.removeItem('MyGarageData');
    localStorage.setItem('product_categoryType', JSON.stringify(type));
    const targetId =
      data?.part_number ||
      data?.inventory_id ||
      data?.id ||
      data?.part_detail?.part_number ||
      data?.part_detail?.inventory_id;
    if (!targetId) {
      console.warn('Cannot navigate to product details: missing identifier', data);
      this.notificationService.error('Product details unavailable for this item.');
      return;
    }
    this.router.navigate(['/product-detail/' + targetId], {
      queryParams: { preserveScroll: 'true' },
    });
  }

  addToCart(event: Event, partNumber: any) {
    event.stopPropagation(); // Prevent navigation to product details

    // Mark as touched so validation messages can show after click
    if (partNumber) {
      partNumber.quantityTouched = true;
      this.cdr.markForCheck();
    }

    // Check if quantity validation fails
    if (this.shouldDisableButtons(partNumber)) {
      this.notificationService.error(
        'Please select a valid quantity before adding to cart',
      );
      this.cdr.markForCheck();
      return;
    }

    // Stock availability check
    if (!this.checkStockAvailability(partNumber)) {
      return;
    }

    // Check if user is logged in
    const isLoggedIn = this.authService.isLoggedIn;
    let userData = null;
    try {
      const userDataString = localStorage.getItem('userData1');
      if (userDataString && !userDataString.startsWith('U2FsdGVkX1')) {
        userData = JSON.parse(userDataString);
      }
    } catch (e) {}

    const hasUser = isLoggedIn && userData && (userData as any)?.id;

    if (!hasUser) {
      // Non-logged in guest user: Add to local storage cart directly
      const productData =
        this.products.find(
          (product: any) =>
            product.inventory_id === partNumber?.inventory_id,
        ) || partNumber;

      if (productData) {
        const quantity = this.getQuantityForPopup(productData);
        const unit =
          productData.selectedUnit === 'kg'
            ? 'Kg'
            : productData.selectedUnit === 'liter'
              ? 'Litr'
              : 'Ton';

        this.cartService.addToLocalStorage(
          productData,
          'Store Pickup',
          quantity,
          unit,
        );
        this.itemAddedToCart.set(partNumber?.inventory_id, true);
        this.cdr.detectChanges();
      }
      return;
    }

    // Logged in user: proceed with certificate check / add to cart API
    const unit =
      partNumber.selectedUnit === 'kg'
        ? 'Kg'
        : partNumber.selectedUnit === 'liter'
          ? 'Litr'
          : 'Ton';
    this.cartService.handleAddToCart(
      partNumber, // Pass the product data
      'Store Pickup',
      this.getQuantityForPopup(partNumber),
      unit,
      () => {
        // Callback for non-scrap parts
        this.addToCartForNonScrapParts(partNumber);
      },
      () => {
        // Callback for login required
        this.openLoginPopup();
      },
    );
  }

  private addToCartForNonScrapParts(partNumber: any) {
    // Check if user is logged in
    let userData = {};
    try {
      const userDataString = localStorage.getItem('userData1');
      if (userDataString && !userDataString.startsWith('U2FsdGVkX1')) {
        userData = JSON.parse(userDataString);
      }
    } catch (error) {
      this.notificationService.error(
        'Error parsing user data. Please log in again.',
      );
    }
    if (!userData || !(userData as any)?.id) {
      // Find the product data from the products array
      const productData = this.products.find(
        (product: any) => product.inventory_id === partNumber?.inventory_id,
      );
      if (productData) {
        // Get quantity and unit for scrap parts
        const quantity = this.getQuantityForPopup(productData);
        const unit =
          productData.selectedUnit === 'kg'
            ? 'Kg'
            : productData.selectedUnit === 'liter'
              ? 'Litr'
              : 'Ton';

        // Add to local storage for non-logged in users with complete product data
        this.cartService.addToLocalStorage(
          productData,
          'Store Pickup',
          quantity,
          unit,
        );
        this.itemAddedToCart.set(partNumber?.inventory_id, true); // Mark as added for non-logged in users
        this.cdr.detectChanges();
      }
      return;
    }
    localStorage.removeItem('addtocartpart_type');
    localStorage.removeItem('MyGarageData');
    localStorage.setItem(
      'addtocartpart_type',
      this.isScrapPart ? 'Scrap Part' : 'Used Part',
    );

    // Get quantity and unit for scrap parts
    const quantity = this.getQuantityForPopup(partNumber);
    const unit =
      partNumber.selectedUnit === 'kg'
        ? 'Kg'
        : partNumber.selectedUnit === 'liter'
          ? 'Litr'
          : 'Ton';

    this.sub.add(
      this.cartService
        .addToCart(partNumber?.inventory_id, 'Store Pickup', quantity, unit)
        .subscribe({
          next: () => {
            this.itemAddedToCart.set(partNumber?.inventory_id, true); // Set success state
         
            this.cdr.detectChanges();
            // Removed automatic navigation to cart after 3 seconds
          },
          error: (err) => {
            // this.notificationService.error(
            //   err.error?.data?.msg ||
            //     'Failed to add item to cart. Please try again.',
            // );
            this.cdr.detectChanges();
            this.itemAddedToCart.set(partNumber?.inventory_id, false); // Mark as failed
          },
          complete: () => {
            // No loader needed
          },
        }),
    );
  }

  goToCart() {
    this.cartService.navigateToCart();
  }

  openLoginPopup() {
    // Use the shared login modal service
    this.behaviourSubject.openLoginModal('other');
  }

  goToCartWithEvent(event: Event) {
    event.stopPropagation(); // Prevent navigation to product details
    this.cartService.navigateToCart();
  }

  getCurrentImage(product: any) {
    if (product?.part_image_path && product?.part_image_path.length > 0) {
      return product.part_image_path[product.currentImageIndex];
    }
    return 'assets/placeholder.png';
  }

  nextImage(product: any) {
    if (product.part_image_path && product.part_image_path.length > 0) {
      product.currentImageIndex =
        (product.currentImageIndex + 1) % product.part_image_path.length;
    }
  }

  prevImage(product: any) {
    if (product.part_image_path && product.part_image_path.length > 0) {
      product.currentImageIndex =
        (product.currentImageIndex - 1 + product.part_image_path.length) %
        product.part_image_path.length;
    }
  }

  /**
   * Start auto-scrolling images when user hovers over a product
   */
  onProductHover(product: any) {
    // Only work in browser environment
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.hoveredProduct = product;

    // Clear any existing interval first to prevent multiple intervals
    if (this.imageScrollInterval) {
      clearInterval(this.imageScrollInterval);
      this.imageScrollInterval = null;
    }

    // Only start auto-scroll if product has multiple images
    if (product?.part_image_path && product.part_image_path.length > 1) {
      // Ensure currentImageIndex is initialized
      if (typeof product.currentImageIndex !== 'number') {
        product.currentImageIndex = 0;
      }

      // Start auto-scrolling every 2 seconds
      this.imageScrollInterval = setInterval(() => {
        if (
          this.hoveredProduct === product &&
          product.part_image_path?.length > 1
        ) {
          // Calculate next index
          product.currentImageIndex =
            (product.currentImageIndex + 1) % product.part_image_path.length;
          // Manually trigger change detection to update the view
          this.cdr.detectChanges();
        } else {
          // Clear interval if conditions no longer met
          if (this.imageScrollInterval) {
            clearInterval(this.imageScrollInterval);
            this.imageScrollInterval = null;
          }
        }
      }, 2000);
    }
  }

  /**
   * Stop auto-scrolling images when user stops hovering
   */
  onProductHoverEnd() {
    this.hoveredProduct = null;

    // Clear the interval
    if (this.imageScrollInterval) {
      clearInterval(this.imageScrollInterval);
      this.imageScrollInterval = null;
    }
  }

  isSocialShareOpen: boolean = false;
  pageURL: string = window.location.href; // or set as needed

  openSocialSharePopup() {
    this.isSocialShareOpen = true;
  }

  closeSocialSharePopup() {
    this.isSocialShareOpen = false;
  }

  copyMessage() {
    navigator.clipboard.writeText(this.pageURL);
   
  }

  /**
   * Scrolls the page to the top
   */
  // scrollToTop() {
  //   if (isPlatformBrowser(this.platformId)) {
  //     this.viewportScroller.scrollToPosition([0, 0]);

  //   }
  // }

  scrollToTop() {
    if (isPlatformBrowser(this.platformId)) {
      // Use smooth scrolling for better user experience
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  /**
   * Handles unit change for a product
   */
  onUnitChange(product: any, event: any) {
    const selectedUnit = event.target.value;
    product.selectedUnit = selectedUnit;
    product.quantityTouched = true;

    if (selectedUnit === 'kg') {
      // When switching to kg, clear ton-related custom quantities
      product.quantity = null;
      product.customTonQuantity = '';
      product.customLiterQuantity = '';
      // Initialize kg quantity if not set
      if (!product.customKgQuantity) {
        product.customKgQuantity = '';
      }
    } else if (selectedUnit === 'liter') {
      // When switching to liter, clear other unit quantities
      product.quantity = null;
      product.customTonQuantity = '';
      product.customKgQuantity = '';
      // Initialize liter quantity if not set
      if (!product.customLiterQuantity) {
        product.customLiterQuantity = '';
      }
    } else {
      // When switching to ton, reset to default quantity and clear other quantities
      product.quantity = 1;
      product.customTonQuantity = '';
      product.customKgQuantity = '';
      product.customLiterQuantity = '';
    }
  }

  /**
   * Handles quantity change for ton units (legacy method for compatibility)
   */
  onQuantityChange(product: any, event: any) {
    const selectedQuantity = event.target.value;
    product.quantityTouched = true;
    if (selectedQuantity === 'custom') {
      product.quantity = 'custom';
      // Initialize custom quantity if not already set
      if (!product.customTonQuantity) {
        product.customTonQuantity = '';
      }
    } else {
      product.quantity = parseFloat(selectedQuantity) || 1;
      // Clear custom quantity when selecting predefined option
      product.customTonQuantity = '';
    }
  }

  /**
   * Handles select dropdown changes for ton quantity
   */
  onTonQuantitySelect(product: any, event: any) {
    const value = event.target.value;
    product.quantityTouched = true;

    if (value === 'custom') {
      product.quantity = 'custom';
      product.customTonQuantity = '';
      // Focus the input field after Angular updates
      setTimeout(() => {
        const customInput = document.querySelector(
          `#customInput-${product.part_number}`,
        ) as HTMLInputElement;
        if (customInput) {
          customInput.focus();
        }
      }, 0);
    } else if (value) {
      product.quantity = parseFloat(value);
      product.customTonQuantity = '';
    } else {
      product.quantity = '';
      product.customTonQuantity = '';
    }
  }

  /**
   * Handles input changes for custom ton quantity
   */
  onCustomTonQuantityInput(product: any, event: any) {
    const value = event.target.value;
    product.customTonQuantity = value;
    product.quantityTouched = true;
  }

  /**
   * Handles blur event for quantity inputs - keeps error visible
   */
  onQuantityBlur(product: any) {
    // Simply ensure quantityTouched stays true
    // Don't reset quantity - let error persist if invalid
    product.quantityTouched = true;
  }

  /**
   * Gets the current display value for ton quantity input
   */
  getCurrentTonQuantityValue(product: any): string {
    if (product.quantity === 'custom') {
      return product.customTonQuantity || '';
    } else if (
      product.quantity === '' ||
      product.quantity === null ||
      product.quantity === undefined
    ) {
      return '';
    } else {
      return product.quantity.toString();
    }
  }

  /**
   * Handles input events for ton quantity (real-time typing)
   * Only works when selectedUnit is 'ton'
   */
  onTonQuantityInput(product: any, event: any) {
    // Only apply custom quantity logic for ton units
    if (product.selectedUnit !== 'ton') {
      return;
    }

    const value = event.target.value;
    // Allow empty value or valid numbers
    if (value === '' || !isNaN(parseFloat(value))) {
      const predefinedOptions = [1, 2, 3, 4, 5, 10, 15, 20, 25, 50];
      const numValue = parseFloat(value);

      if (predefinedOptions.includes(numValue)) {
        // It's a predefined option
        product.quantity = numValue;
        product.customTonQuantity = '';
      } else {
        // It's a custom value
        product.quantity = 'custom';
        product.customTonQuantity = value;
      }
      product.quantityTouched = true;
    }
  }

  /**
   * Handles change events for ton quantity (when user finishes input)
   * Only works when selectedUnit is 'ton'
   */
  onTonQuantityChange(product: any, event: any) {
    // Only apply custom quantity logic for ton units
    if (product.selectedUnit !== 'ton') {
      return;
    }

    const value = event.target.value;
    const numValue = parseFloat(value);

    if (value === '' || isNaN(numValue)) {
      // Keep empty if user cleared the field
      product.quantity = '';
      product.customTonQuantity = '';
    } else {
      const predefinedOptions = [1, 2, 3, 4, 5, 10, 15, 20, 25, 50];

      if (predefinedOptions.includes(numValue)) {
        product.quantity = numValue;
        product.customTonQuantity = '';
      } else {
        product.quantity = 'custom';
        product.customTonQuantity = value;
      }
    }
    product.quantityTouched = true;
  }

  /**
   * Handles custom kg quantity input
   */
  /**
   * Handles quantity change for liter units
   */
  onLiterQuantityChange(product: any, event: any) {
    const value = event.target.value;
    // Allow only numbers and decimal points
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      product.customLiterQuantity = value;
    }
    product.quantityTouched = true;
  }

  onKgQuantityChange(product: any, event: any) {
    const value = event.target.value;
    // Allow only numbers and decimal points
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      product.customKgQuantity = value;
    }
    product.quantityTouched = true;
  }

  /**
   * Handles custom ton quantity input
   */
  onCustomTonQuantityChange(product: any, event: any) {
    const value = event.target.value;
    // Allow only numbers and decimal points
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      product.customTonQuantity = value;
    }
    product.quantityTouched = true;
  }

  /**
   * Gets the current quantity display for a product
   */
  /**
   * Check if product is oil category with liter UOM
   */
  isOilProductWithLiter(product: any): boolean {
    if (!product) return false;

    // Check if default_uom is liter/litr/ltr (API returns "ltr")
    const isLiterUom =
      product.default_uom?.toLowerCase() === 'ltr' ||
      product.default_uom?.toLowerCase() === 'litr' ||
      product.default_uom?.toLowerCase() === 'liter' ||
      product.defaultUom?.toLowerCase() === 'ltr' ||
      product.defaultUom?.toLowerCase() === 'litr' ||
      product.defaultUom?.toLowerCase() === 'liter';

    if (!isLiterUom) return false;

    // Check if category contains oil or fluids (using includes for "OIL / Fluids" format)
    const scrapCategoryLower = product.scrap_category?.toLowerCase() || '';
    const categoryLower = product.category?.toLowerCase() || '';
    const materialLower = product.material?.toLowerCase() || '';
    const materialCompositionLower =
      product.material_composition?.toLowerCase() || '';
    const nameLower = product.name?.toLowerCase() || '';

    const isOilCategory =
      scrapCategoryLower.includes('oil') ||
      scrapCategoryLower.includes('fluids') ||
      categoryLower.includes('oil') ||
      categoryLower.includes('fluids') ||
      materialLower.includes('oil') ||
      materialLower.includes('fluids') ||
      materialCompositionLower.includes('oil') ||
      materialCompositionLower.includes('fluids') ||
      nameLower.includes('oil') ||
      nameLower.includes('fluids');

    const result = isOilCategory && isLiterUom;

    // Debug log
    if (
      product.default_uom === 'ltr' ||
      product.default_uom === 'litr' ||
      product.default_uom === 'liter'
    ) {
      console.log('🔍 Oil Product Check:', {
        name: product.table_name || product.name,
        default_uom: product.default_uom,
        material: product.material,
        scrap_category: product.scrap_category,
        isLiterUom: isLiterUom,
        isOilCategory: isOilCategory,
        result: result,
      });
    }

    return result;
  }

  getCurrentQuantity(product: any): string {
    if (product.selectedUnit === 'kg') {
      // For kg units, just return the direct input value
      return product.customKgQuantity || '';
    } else if (product.selectedUnit === 'liter') {
      // For liter units, return the custom liter quantity
      return product.customLiterQuantity || '';
    } else {
      // For ton units, handle custom quantity logic
      if (product.quantity === 'custom') {
        return product.customTonQuantity || '';
      } else if (
        product.quantity === '' ||
        product.quantity === null ||
        product.quantity === undefined
      ) {
        return '';
      } else {
        return product.quantity.toString();
      }
    }
  }

  /**
   * Gets the display value for ton quantity input field
   */
  getTonQuantityDisplayValue(product: any): string {
    if (product.quantity === 'custom') {
      return product.customTonQuantity || '';
    } else {
      return product.quantity?.toString() || '1';
    }
  }

  /**
   * Gets the quantity value for the buy now popup
   * Handles both kg and ton units properly
   */
  getQuantityForPopup(product: any): number {
    if (!product) return 1;

    if (product.selectedUnit === 'kg') {
      // For kg units, return custom kg quantity or default to 1
      if (!product.customKgQuantity || product.customKgQuantity === '') {
        return 1;
      }
      const kgQty = parseFloat(product.customKgQuantity);
      return isNaN(kgQty) || kgQty <= 0 ? 1 : kgQty;
    } else if (product.selectedUnit === 'liter') {
      // For liter units, return custom liter quantity or default to 1
      if (!product.customLiterQuantity || product.customLiterQuantity === '') {
        return 1;
      }
      const literQty = parseFloat(product.customLiterQuantity);
      return isNaN(literQty) || literQty <= 0 ? 1 : literQty;
    } else {
      // For ton units, check if custom entry is selected
      if (product.quantity === 'custom') {
        // When custom is selected, return the actual custom quantity value, not 'custom'
        if (!product.customTonQuantity || product.customTonQuantity === '') {
          return 1;
        }
        const customQty = parseFloat(product.customTonQuantity);
        return isNaN(customQty) || customQty <= 0 ? 1 : customQty;
      } else if (
        product.quantity === '' ||
        product.quantity === null ||
        product.quantity === undefined
      ) {
        return 1;
      } else {
        // Return the numeric quantity value
        const qty =
          typeof product.quantity === 'number'
            ? product.quantity
            : parseFloat(product.quantity);
        return isNaN(qty) || qty <= 0 ? 1 : qty;
      }
    }
  }

  /**
   * Gets the selected quantity for a product based on the current unit
   * Returns quantity in kg for consistent comparison
   */
  getSelectedQuantity(product: any): number {
    if (!product) return 0;
    if (product.part_type === 'Scrap Part') {
      if (product.selectedUnit === 'kg') {
        // For kg units, return custom kg quantity or 0 if not set
        if (!product.customKgQuantity || product.customKgQuantity === '') {
          return 0;
        }
        const qty = parseFloat(product.customKgQuantity);
        return isNaN(qty) ? 0 : qty;
      } else if (product.selectedUnit === 'liter') {
        // For liter units, return custom liter quantity or 0 if not set
        if (
          !product.customLiterQuantity ||
          product.customLiterQuantity === ''
        ) {
          return 0;
        }
        const qty = parseFloat(product.customLiterQuantity);
        return isNaN(qty) ? 0 : qty;
      } else {
        // For ton units, convert to kg (1 ton = 1000 kg)
        let tonQuantity = 0;
        if (product.quantity === 'custom') {
          // When custom is selected, check if customTonQuantity has a valid value
          if (!product.customTonQuantity || product.customTonQuantity === '') {
            tonQuantity = 0;
          } else {
            const qty = parseFloat(product.customTonQuantity);
            tonQuantity = isNaN(qty) ? 0 : qty;
          }
        } else if (
          product.quantity === '' ||
          product.quantity === null ||
          product.quantity === undefined
        ) {
          tonQuantity = 0;
        } else {
          tonQuantity = product.quantity || 0;
        }
        return tonQuantity * 1000;
      }
    } else {
      // For Used Parts, return quantity or default to 1
      return product.quantity || 1;
    }
  }

  /**
   * Gets the available quantity for a product in kg
   */
  getAvailableQuantity(product: any): number {
    if (!product) return 0;

    // Always use available_quantity as the available stock for validation
    return product.available_quantity || 0;
  }

  /**
   * Validates if the selected quantity is available
   * Compares quantities in kg for consistency
   */
  isQuantityAvailable(product: any): boolean {
    const selectedQuantityInKg = this.getSelectedQuantity(product);
    const availableQuantityInKg = this.getAvailableQuantity(product);
    // Use product.min_quantity or min_qty from API (default to 0 if not provided to show validation)
    const minQuantityInKg = product.min_quantity || product.min_qty || 0;
    return (
      selectedQuantityInKg >= minQuantityInKg &&
      selectedQuantityInKg <= availableQuantityInKg
    );
  }

  /**
   * Validates stock availability before adding to cart
   * Checks available quantity (stock - reserved) against requested quantity
   */
  private checkStockAvailability(product: any): boolean {
    if (!product) return false;

    // Get stock and reserved quantities from API response
    const stockQuantity =
      Number(product.stock_quantity_s || product.STOCK_QUANTITY_s) || 0;
    const reservedQuantity =
      Number(product.reserved_quantity || product.RESERVED_QUANTITY_s) || 0;
    const availableQuantity =
      product.available_quantity !== undefined
        ? Number(product.available_quantity)
        : stockQuantity - reservedQuantity;

    // Get requested quantity
    const requestedQuantity = this.getQuantityForPopup(product) || 1;

    // Check if available stock exists and if requested quantity exceeds it
    if (availableQuantity > 0 && requestedQuantity > availableQuantity) {
      const unit = product.selectedUnit || 'units';
      const errorMsg = `Quantity exceeds available stock. Available quantity is ${availableQuantity} ${unit}.`;
      this.notificationService.error(errorMsg);
      return false;
    }

    // Check if no stock available
    if (availableQuantity <= 0) {
      this.notificationService.error('This product is currently out of stock.');
      return false;
    }

    return true;
  }

  /**
   * Converts fix_quantity to tons
   * Assumes fix_quantity is in kg
   */
  getStockInTons(product: any): number {
    if (!product || !product.available_quantity) return 0;

    // Convert kg to tons (1 ton = 1000 kg)
    return Math.floor(product.available_quantity / 1000);
  }

  /**
   * Generates ton dropdown options based on available stock and minimum quantity
   */
  getTonOptions(product: any): number[] {
    const stockInTons = this.getStockInTons(product);
    const minQuantityInTons = this.getMinQuantityInTons(product);
    const options: number[] = [];

    if (!product || !product.available_quantity || !product.min_quantity) {
      return options;
    }

    // Start from minimum quantity in tons (rounded up to nearest ton)
    const startTon = Math.max(1, Math.ceil(minQuantityInTons));

    // Generate options from minimum quantity to available stock in tons
    // Maximum 15 options to keep dropdown manageable
    const maxOptions = Math.min(stockInTons, startTon + 15);

    for (let i = startTon; i <= maxOptions; i++) {
      options.push(i);
    }

    return options;
  }

  /**
   * Gets minimum quantity in tons for input validation
   */
  getMinQuantityInTons(product: any): number {
    const minQty = product.min_quantity || product.min_qty || 0;
    if (!product || !minQty) return 0; // Return 0 if min_quantity not set
    // Convert kg to tons (1 ton = 1000 kg)
    return minQty / 1000;
  }

  /**
   * Gets maximum quantity in tons for input validation
   */
  getMaxQuantityInTons(product: any): number {
    const stockQty =
      product.available_quantity || product.stock_quantity_s || 0;
    if (!product || !stockQty) return 0; // Return 0 if stock not available
    // Convert kg to tons (1 ton = 1000 kg)
    return stockQty / 1000;
  }

  /**
   * Track by function for dropdown options
   */
  trackByIndex(index: number, item: any): any {
    return item;
  }

  /**
   * Track by function for products list to improve rendering performance
   */
  trackByProductId(index: number, product: any): any {
    return product?.part_number || product?.inventory_id || index;
  }

  /**
   * Checks if the product should be disabled due to quantity validation
   */
  shouldDisableButtons(product: any): boolean {
    if (!product) return true;
    // For scrap parts, require user to explicitly select a quantity first
    if (product.part_type === 'Scrap Part') {
      const selectedQty = this.getSelectedQuantity(product);
      // Disable if quantity is not selected (0 or null) or if quantity is invalid
      if (
        selectedQty === 0 ||
        selectedQty === null ||
        selectedQty === undefined
      ) {
        return true;
      }
      // Also check if quantity is available and valid
      return !this.isQuantityAvailable(product);
    }
    // For Used Parts, validate against fix_quantity only if it's available
    const selectedQty = this.getSelectedQuantity(product);
    const availableQty = this.getAvailableQuantity(product);
    // If fix_quantity is not set or 0, don't disable (allow add to cart/buy now)
    if (availableQty === 0) {
      return false;
    }
    return selectedQty > availableQty;
  }

  loadDataFromLocalStorage() {
    if (isPlatformBrowser(this.platformId)) {
      // Reset data
      this.products = [];
      this.productData = [];
      this.currentPage = 1;
      this.offset = 0;

      // Read localStorage data
      const storedData = localStorage.getItem('guideSearchData');
      const seeMore = localStorage.getItem('seemore');
      const category = localStorage.getItem('category');
      const categoryType = JSON.parse(
        localStorage.getItem('categoryType') || 'null',
      );

      this.isScrapPart = categoryType === 'Scrap Part' ? true : false;
      this.categoryData = category ? JSON.parse(category) : null;

      // Read mostSearchedModels from localStorage
      this.mostSearchedModels = JSON.parse(
        localStorage.getItem('mostSearchedModel') || 'null',
      );

      // Set filterpassData based on priority: categoryData > mostSearchedModels
      // Do not override if user manually selected a category
      if (!this.userSelectedCategory) {
        if (this.categoryData) {
          this.selectedCategoryId = this.categoryData.id;
          this.selectedCategory = this.categoryData;
          this.filterpassData = this.categoryData;

          // Check if category has subcategories and show them
          // Note: subcategories will be set after categories are loaded from API
          this.subcategories = [];
          this.showSubcategories = false;
        } else if (this.mostSearchedModels) {
          this.filterpassData = this.mostSearchedModels;
          // Reset category selection if using mostSearchedModels
          this.selectedCategoryId = null;
          this.selectedCategory = null;
          this.subcategories = [];
          this.showSubcategories = false;
        } else {
          // Reset selection if no data available
          this.selectedCategoryId = null;
          this.selectedCategory = null;
          this.subcategories = [];
          this.showSubcategories = false;
          this.filterpassData = null;
        }
      }

      // Trigger change detection to ensure filter component receives the updated data
      this.cdr.detectChanges();

      this.get_your_vehicles = seeMore === 'your_vehicles';
      this.is_scrap_see_more = seeMore === 'popular_scrap';
      this.get_popular_brands = seeMore === 'popular_brands';
      this.get_popular_vehicles = seeMore === 'popular_vehicles';
      this.get_popular_categories = seeMore === 'popular_categories';
      this.get_popular_parts = seeMore === 'popular_parts';
      this.get_popular_scrap = seeMore === 'popular_scrap';
      this.guideSearch = storedData ? JSON.parse(storedData) : null;

      // Call getProductList with the new data
      this.getProductList();
    }
  }

  getFilterList(showLoader: boolean = false) {
    // Filters should NOT block PLP rendering; default is non-blocking
    if (showLoader) {
      this.loaderService.show();
    }
    try {
      let data = {
        limit: 50,
        offset: 0,
        search_text: this.searchText || this.guideSearch?.search_text || '',
        filter_type:'Scrap Part',
          // this.isScrapPart || this.guideSearch?.part_type === 'Scrap Part'
          //   ? 'Scrap Part'
          //   : 'Used Part',
        make_list:'',
          // this.isScrapPart || this.guideSearch?.part_type === 'Scrap Part'
          //   ? ''
            // : this.guideSearch?.make
            //   ? this.guideSearch.make
            //   : this.sparePartsType?.VEHICLE_MAKE_s
            //     ? this.sparePartsType.VEHICLE_MAKE_s
            //     : this.mostSearchedModels?.make
            //       ? this.mostSearchedModels.make
            //       : this.garageData?.make
            //         ? this.garageData?.make
            //         : '',
        model_list:
          this.isScrapPart || this.guideSearch?.part_type === 'Scrap Part'
            ? ''
            : '',
        variant_list:'',
          // this.guideSearch?.variant
          //   ? this.guideSearch.variant
          //   : this.guideSearch?.variant
          //     ? this.guideSearch?.variant
          //     : this.sparePartsType?.VARIANT_s
          //       ? this.sparePartsType.VARIANT_s
          //       : this.garageData?.variant
          //         ? this.garageData?.variant
          //         : '',
        year_of_manufacture_list: this.guideSearch?.year_of_manufacture
          ? this.guideSearch.year_of_manufacture
          : this.guideSearch?.year_of_manufacture
            ? this.guideSearch?.year_of_manufacture
            : this.sparePartsType?.YEAR_OF_MANUFACTURE_s
              ? this.sparePartsType?.YEAR_OF_MANUFACTURE_s
              : this.garageData?.year_of_manufacture
                ? this.garageData?.year_of_manufacture
                : '',
        // "seller": this.data ? this.data?.model : '',
        // "quality": this.data ? this.data?.model : '',
        category_list:
          this.isScrapPart || this.guideSearch?.part_type === 'Scrap Part'
            ? this.guideSearch?.category || this.categoryData?.name
              ? this.guideSearch?.category || this.categoryData?.name
              : this.filterpassData?.name
                ? this.filterpassData?.name
                : this.guideSearch?.category
                  ? this.guideSearch.category
                  : this.categoryData?.name
                    ? this.categoryData?.name
                    : this.guideSearch?.make
                      ? this.guideSearch?.make
                      : ''
            : this.selectedCategory?.name
              ? [this.selectedCategory?.name]
              : [],

        //  category:
        //   this.isScrapPart || this.guideSearch?.part_type === 'Scrap Part'
        //     ? this.guideSearch?.make
        //     : this.guideSearch?.category
        //     ? this.guideSearch.category
        //     : this.guideSearch?.category
        //     ? this.guideSearch?.category
        //     : this.categoryData?.name
        //     ? this.categoryData?.name
        //     : this.filterpassData?.name
        //     ? this.filterpassData?.name
        //     : '',
        sub_category_list:'',
          // this.isScrapPart || this.guideSearch?.part_type === 'Scrap Part'
          //   ? this.guideSearch?.model
          //   : '',
        // : this.selectedSubcategory?.name ? [this.selectedSubcategory?.name] : '',
        //  this.guideSearch?.sub_category_a
        // : this.categoryData?.sub_category_a
        // ? this.categoryData?.sub_category_a
        // : this.filterpassData?.sub_category_a
        // ? this.filterpassData?.sub_category_a
        // : '',
      };
      // this.loaderService.show()

      this.sub.add(
        this.apiService.getFilters(data).subscribe({
          next: (value) => {
            if (value.success) {
              if (showLoader) {
                this.loaderService.hide();
              }
              const filters = value.data.filters;

              // Bind categories data
              // if (filters.category && filters.category.length > 0) {
              this.categories = filters.category;

              // After categories are loaded, check if we need to set up subcategories for categoryData
              if (
                this.categoryData &&
                this.selectedCategoryId === this.categoryData.id
              ) {
                const matchingCategory = this.categories.find(
                  (cat) => cat.id === this.categoryData.id,
                );
                if (
                  matchingCategory &&
                  matchingCategory.subcategories &&
                  matchingCategory.subcategories.length > 0
                ) {
                  this.subcategories = matchingCategory.subcategories;
                  this.showSubcategories = true;
                } else {
                  this.subcategories = [];
                  this.showSubcategories = false;
                }
              }
              // }

              // Bind all filter data from API response
              // this.brands = filters.make || [];
              // this.models = filters.model || [];
              // this.variants = filters.variant || [];
              // this.years = filters.year || [];
              // this.sellers = filters.seller || [];
              // this.qualities = filters.quality || [];
              // this.locations = filters.location || [];
              // this.priceRanges = filters.price_range || [];

              // Set price slider values
              // if (filters.price_slider) {
              //   this.minValue = filters.price_slider.min_price || 0;
              //   this.maxValue = filters.price_slider.max_price || 10000;
              // }

              // Don't call updateSelectedFilters here as it's already called in applySavedFiltersToData
            } else {
              // this.filtersData = [];
            }
            // Trigger change detection after filters are loaded
            this.cdr.detectChanges();
            if (showLoader) {
              this.loaderService.hide();
            }
          },
          error: (err) => {
            this.notificationService.error(
              err.error?.data?.msg ||
                'Failed to load filters. Please refresh the page.',
            );
            if (showLoader) {
              this.loaderService.hide();
            }
            // No need to hide loader as it's managed by getProductList
          },
          complete: () => {
            // Loader is managed by getProductList, no need to hide here
            if (showLoader) {
              this.loaderService.hide();
            }
          },
        }),
      );
    } catch (error: any) {
      // this.notificationService.error(
      //   error.error?.data?.msg ||
      //     'An unexpected error occurred. Please try again.',
      // );
      if (showLoader) {
        this.loaderService.show();
      }

      throw error;
    }
  }

  /**
   * Clears all applied filters when user navigates from header categories
   * This ensures a fresh start when user clicks on Used Parts or Scrap Parts
   * Note: This preserves the category selection from header navigation
   */
  clearFiltersFromHeaderNavigation() {
    this.filterComponent?.resetFiltersForCategoryChange();
    // Clear filters through behavior subject but preserve category selection
    this.behaviourSubject.clearSelectedFilters();

    // Reset local filter properties except category-related ones
    this.selectedFilters = null;
    this.searchText = '';

    // Explicitly clear search text in behavior subject
    this.behaviourSubject.setSearchTerm('');

    // Reset pagination
    this.currentPage = 1;
    this.offset = 0;      
    this.categoryData = null;
    this.selectedCategory = (_category: any) => {}; // Reset category selection to trigger product list refresh without filters
    // Clear any stored filter state but preserve category data
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('filterState');
      // Note: We don't remove 'category' and 'categoryType' as they are set by header navigation
    }

    // Trigger a product list refresh to show products for the new category without filters
    this.getProductList();
  }

  /**
   * Get formatted delivery date (3 business days from today)
   */
  getDeliveryDate(): string {
    return this.deliveryDateService.calculateDeliveryDate(3);
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    // Hide loader before unsubscribing to prevent stuck loader
    this.loaderService.hide();

    // Clear debounce timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = null;
    }

    // Clear image scroll interval to prevent memory leaks
    if (this.imageScrollInterval) {
      clearInterval(this.imageScrollInterval);
      this.imageScrollInterval = null;
    }

    this.sub.unsubscribe();
    this.behaviourSubject.clearSelectedFilters();
    this.behaviourSubject.clearCategoryChanged();
  }
}

interface Category {
  id: number;
  title: string;
  imageUrl: string;
  partsCount: number;
  backgroundColor?: string;
  multilineTitle?: boolean;
  badgeUrl?: string;
  selected?: boolean;
}
